import './tcms_core_jquery.js';

window.c24 = window.c24 || {};

// App Splash Hooks
window.c24.appSplashScreen = window.c24.appSplashScreen || {};
window.c24.appSplashScreen.init = window.c24.appSplashScreen.init || function() {
};
window.c24.appSplashScreen.hooks = window.c24.appSplashScreen.hooks || {};

if (!('onClose' in window.c24.appSplashScreen.hooks)) {
    window.c24.appSplashScreen.hooks.onClose = () => {
        console.log('App Splash Closed');
    };
}

// Base is ready. Fire App Splash Init
window.c24.appSplashScreen.init();
